import { createRoot, hydrateRoot } from 'react-dom/client';
import createCache from '@emotion/cache';
import { App } from '@/App';
import { AppProviders } from '@/components/ui/provider';
import { normalizePath } from '@/lib/paths';
import { createStore } from '@/store';
import '@fontsource-variable/syne';
import '@fontsource-variable/manrope';
import '@/styles/global.css';

const store = createStore();
const emotionCache = createCache({ key: 'swezey' });
const root = document.getElementById('root');
const url = normalizePath(window.location.pathname);

if (!root) {
  throw new Error('Root element #root was not found');
}

const tree = (
  <AppProviders store={store} emotionCache={emotionCache}>
    <App url={url} />
  </AppProviders>
);

if (root.hasChildNodes()) {
  hydrateRoot(root, tree);
} else {
  createRoot(root).render(tree);
}
